import { getWorkerUrl } from '../utils/env';

export type TrackEvent =
  | 'cta_demand_clicked'
  | 'demand_form_opened'
  | 'demand_submitted'
  | 'demand_assist_used'
  | 'demand_matches_shown'
  | 'owner_responded'
  | 'search_performed'
  | 'listing_detail_opened'
  | 'contact_opened'
  | 'contact_sent'
  | 'runtime_error';

export function trackEvent(event: TrackEvent, data?: Record<string, any>) {
  try {
    if (typeof window === 'undefined') return;

    if ((window as any).gtag) {
      (window as any).gtag('event', event, data);
    }

    // First-party sink: feeds the admin funnel metrics in D1. Fire-and-forget.
    const workerUrl = getWorkerUrl('D1');
    if (workerUrl) {
      fetch(`${workerUrl}/api/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event, data }),
        keepalive: true,
      }).catch(() => { /* tracking must never break the app */ });
    }

    console.log(`[Tracking] 📊 ${event}`, data || '');
  } catch (e) {
    // ignore tracking errors
  }
}
